import { render, staticRenderFns } from "./editCustomDetailActivity.vue?vue&type=template&id=a2ed6e1a"
import script from "./editCustomDetailActivity.vue?vue&type=script&lang=js"
export * from "./editCustomDetailActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports